module.exports = __webpack_public_path__ + "static/media/platforms-mac.a1cdb2cc.svg";